import React from 'react';
import { AfterSubmitFunc, FormTemplate } from 'ui-builder';
import { useProjectDocumentsService } from 'nekst-api';
import { DocumentTemplateDropdown } from './DocumentTemplateDropdown';

export function ApplyTemplateForm(
  props: {
    projectId: number,
    afterSubmitFunc?: AfterSubmitFunc,
    testID?: string,
  },
) {
  const projectDocumentsService = useProjectDocumentsService();
  return (
    <FormTemplate<{ templateId: number }>
      title="Apply Template"
      testID={props.testID}
      submitFormFunc={async (data) => {
        await projectDocumentsService.applyTemplate(props.projectId, data.templateId);
        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <DocumentTemplateDropdown source="templateId" label="Template" />
    </FormTemplate>
  );
}
